import React from 'react';

const HelpPulseRing = ({ rect }) => {
    if (!rect) return null;

    const PADDING = 8;
    const style = {
        top: rect.top - PADDING,
        left: rect.left - PADDING,
        width: rect.width + PADDING * 2,
        height: rect.height + PADDING * 2,
    };

    return (
        <div className="fixed pointer-events-none z-[305]" style={style}>
            {/* Subtle glow behind */}
            <div className="absolute inset-[-4px] rounded-2xl bg-blue-500/5 dark:bg-blue-400/5" />
            {/* Static highlight border */}
            <div className="absolute inset-0 rounded-2xl border-2 border-blue-500/60 dark:border-blue-400/60" />
            {/* Pulsing ring 1 */}
            <div className="absolute inset-0 rounded-2xl border-2 border-blue-500/40 dark:border-blue-400/40 animate-help-ping" />
            {/* Pulsing ring 2 (delayed) */}
            <div className="absolute inset-0 rounded-2xl border-2 border-blue-500/20 dark:border-blue-400/20 animate-help-ping-delayed" />
        </div>
    );
};

export default HelpPulseRing;
